import { useState, useEffect } from "react";

import VacancySkeleton from "../components/Skeleton";
import ScrollTop from "../features/ScrollTop";

function MainCareers() {
  const [openings, setOpenings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.title = "Careers | AttnQ";
  }, []);

  useEffect(() => {
    fetch("https://attnq.free.beeceptor.com/vacancies")
      .then((res) => {
        if (!res.ok)
          throw new Error(
            "There was an error updating available openings. Please try again after sometime"
          );
        return res.json();
      })
      .then((data) => {
        setOpenings(data);
      })
      .catch((err) => {
        setErr(
          "There was an error updating available openings. Please try again after sometime."
        );
      })
      .finally(() => setLoading(false));
  }, []);

  const hrContacts = [
    {
      id: 1,
      name: "HR Desk",
      role: "Human Resource",
      email: "hr@attnq.com",
    },
  ];

  return (
    <main className="w-full h-fit px-6 lg:px-32 py-16 mt-14 shadow">
      <ScrollTop />
      <div className="flex flex-col gap-10 md:flex-row mt-[-3rem]">
        <section className="flex-1">
          <h2 className="text-2xl font-semibold py-6">Open Positions</h2>

          <ul className="space-y-4">
            {loading === true ? (
              <VacancySkeleton />
            ) : err == null ? (
              openings.map((job) => (
                <li
                  key={job.id}
                  onClick={() => setIsOpen(!isOpen)}
                  className="bg-yellow-50 border cursor-pointer rounded-lg p-5 flex flex-col md:flex-row md:items-center md:justify-between hover:shadow transition"
                >
                  <div>
                    <p className="font-medium text-lg">{job.title}</p>
                    <p className="text-sm text-gray-500">{job.location}</p>
                    <p className="text-sm text-gray-500">{`Required ${job.exp} Years of Experience`}</p>

                    {isOpen && (
                      <div className="mt-4 text-sm text-gray-600 space-y-2 border-t p-4">
                        <p className="p-2">
                          <strong>Description:</strong>{" "}
                          {job.description || "N/A"}
                        </p>
                        <p className="p-1 pl-4">
                          <strong>1:</strong> {job.descA || "N/A"}
                        </p>
                        <p className="p-1 pl-4">
                          <strong>2:</strong> {job.descB || "N/A"}
                        </p>
                        <p className="p-1 pl-4">
                          <strong>3:</strong> {job.descC || "N/A"}
                        </p>
                        <p className="p-1 pl-4">
                          <strong>4:</strong> {job.descD || "N/A"}
                        </p>
                        <p className="p-2">
                          <strong>Estimate Salary:</strong> {job.pay || "N/A"}
                        </p>
                        <p className="p-2">
                          <strong>Status:</strong> {job.status || "Filled"}
                        </p>
                      </div>
                    )}
                  </div>
                  <span className="mt-2 md:mt-0 inline-block px-3 py-1 bg-amber-100 text-amber-800 text-xs rounded-full">
                    {job.type}
                  </span>
                </li>
              ))
            ) : (
              <p>{err}</p>
            )}
          </ul>
        </section>

        <aside className="md:w-80">
          <h2 className="text-2xl font-semibold py-6">HR Contact</h2>

          <ul className="space-y-4">
            {hrContacts.map((hr) => (
              <li
                key={hr.id}
                className="bg-yellow-50 border rounded-lg p-5 flex flex-col gap-1"
              >
                <p className="font-medium">{hr.name}</p>
                <a
                  href={`mailto:${hr.email}`}
                  className="text-sm text-[#dc9209] hover:underline"
                >
                  {hr.email}
                </a>
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </main>
  );
}

export default MainCareers;
